module.exports = __webpack_public_path__ + "img/3.1a329ec9.jpg";